import React from 'react';
import styled from 'styled-components';

const CheckContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  text-align: left;
  margin-bottom: 20px;
  background-color: transparent;

  input {
    margin-right: 8px;
    transition: none;
    height: ${props => props.height && props.height}px;
  }

  label {
    line-height: 1.5;
  }
`;

const Check = ({
	name, onChange, checked, label, labelLink, customLabel, height,
}) => {

	function handleLabel() {
		if (customLabel) {
			return customLabel();
		}

		if (labelLink) {
			return (
				<a href={labelLink} target="_blank" rel="noopener noreferrer">
					<label htmlFor={name}>{label}</label>
				</a>
			);
		}

		return <label htmlFor={name}>{label}</label>;
	}

	return (
		<CheckContainer height={height ? height : undefined}>
			<input
				type="checkbox"
				name={name}
				onChange={onChange}
				checked={checked}
			/>
			{ handleLabel() }
		</CheckContainer>
	);
};

export default Check;
